import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";

const STATES = ["Andhra Pradesh","Assam","Bihar","Delhi","Goa","Gujarat","Haryana","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Punjab","Rajasthan","Tamil Nadu","Telangana","Uttar Pradesh","West Bengal"];

export default function Vendors() {
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: "", gstin: "", state: "Maharashtra", email: "", phone: "" });

  const load = async () => setRows((await api.get("/vendors")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/vendors", form);
      toast.success("Vendor added");
      setShow(false);
      setForm({ name: "", gstin: "", state: "Maharashtra", email: "", phone: "" });
      load();
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5 lb-fade" data-testid="vendors-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Master</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight">Vendors</h1>
        </div>
        <button className="lb-btn" onClick={() => setShow((s) => !s)} data-testid="add-vendor-btn">
          <Plus size={14} /> New Vendor
        </button>
      </div>

      {show && (
        <form onSubmit={submit} className="lb-card p-6 grid grid-cols-3 gap-4">
          <div className="col-span-2">
            <label className="lb-label">Name</label>
            <input required className="lb-input" value={form.name}
                   onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="vf-name" />
          </div>
          <div>
            <label className="lb-label">GSTIN</label>
            <input className="lb-input font-mono uppercase" maxLength={15} value={form.gstin}
                   onChange={(e) => setForm({ ...form, gstin: e.target.value.toUpperCase() })} data-testid="vf-gstin" />
          </div>
          <div>
            <label className="lb-label">State</label>
            <select required className="lb-select" value={form.state}
                    onChange={(e) => setForm({ ...form, state: e.target.value })}>
              {STATES.map((s) => <option key={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="lb-label">Email</label>
            <input type="email" className="lb-input" value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="lb-label">Phone</label>
            <input className="lb-input" value={form.phone}
                   onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div className="col-span-3 flex gap-2">
            <button className="lb-btn" data-testid="vf-submit">Save</button>
            <button type="button" className="lb-btn lb-btn-ghost" onClick={() => setShow(false)}>Cancel</button>
          </div>
        </form>
      )}

      <div className="lb-card">
        <table className="lb-table">
          <thead><tr><th>Name</th><th>GSTIN</th><th>State</th><th>Email</th><th>Phone</th></tr></thead>
          <tbody>
            {rows.map((v) => (
              <tr key={v.id}>
                <td className="font-semibold">{v.name}</td>
                <td className="font-mono text-xs">{v.gstin || "—"}</td>
                <td className="text-sm">{v.state}</td>
                <td className="text-sm">{v.email}</td>
                <td className="text-sm">{v.phone}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={5} className="text-center py-10 text-neutral-500">No vendors</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
